import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '@components/buttons/buttons.module';
import { ModalModule } from '@components/modal/modal.module';
import { AnalysisFinishComponent } from './analysis-finish.component';

@NgModule({
  imports: [CommonModule, ModalModule, ButtonsModule],
  exports: [AnalysisFinishComponent],
  declarations: [AnalysisFinishComponent],
})
export class AnalysisFinishModule {}
